import React, {
  useMemo,
  useState,
} from 'react';

import { Button } from 'antd';
import {
  IoChevronForward,
  IoClose,
} from 'react-icons/io5';
import { PiWarningOctagonFill } from 'react-icons/pi';
import { BottomSheet } from 'react-spring-bottom-sheet';
import TMIcon from 'tm-icons-library';
import { IconName } from 'tm-icons-library/dist/IconTypes';

import CustomParsedReadMoreContent
  from '../../../../components/CustomReadMoreText/CustomParsedReadMoreContent';
import Header from '../../../../components/Header/Header';
import Rupee from '../../../../components/Rupee/Rupee';
import { useTheme } from '../../../../context/ThemeProvider';
import { useAppSelector } from '../../../../shared/hooks';
import {
  dynamicItemTitle,
  newNumberFormat,
} from '../../../../shared/utils';
import RenewFlexiActiveMangoes from './RenewFlexiActiveMangoes';
import RenewMangoTile from './RenewMangoTile';
import {
  IRenewFlexiMango,
  IRenewMango,
} from './types';

interface Props {
  renewMangoes: IRenewMango[];
  activeFlexiMangoes: IRenewFlexiMango[];
}

const RenewMangoes: React.FC<Props> = ({
  renewMangoes,
  activeFlexiMangoes,
}) => {
  console.log('activeFlexiMangoes', activeFlexiMangoes);
  const { colors: COLORS } = useTheme();

  const { deeplinkUrl } = useAppSelector((state) => state.app);

  const [showModal, setShowModal] = useState(false);
  const [hideRenewMangoes, setHideRenewMangoes] = useState(false);

  const firstRenewMango: IRenewMango = useMemo(
    () => renewMangoes[0],
    [renewMangoes],
  );

  const handleRenewalRedirect = (mangoId: string, link?: string) => {
    let url = `${deeplinkUrl}web/checkout/${mangoId}`;

    url += '?purchaseNow=true';

    window.open(link || url, '_blank');
  };

  const onClick = () => {
    if (renewMangoes.length > 1) {
      setShowModal(true);
    } else {
      handleRenewalRedirect(
        firstRenewMango.mango._id,
        firstRenewMango?.mango?.customRenewCardAfterExpiry?.buttonLink,
      );
    }
  };

  if (hideRenewMangoes) {
    return null;
  }

  return (
    <>
      <RenewFlexiActiveMangoes activeFlexiMangoes={activeFlexiMangoes} />
      <div className={`feed-card danger`} onClick={onClick}>
        <div className="feed-card__icon-bar">
          {firstRenewMango?.mango?.customRenewCardAfterExpiry?.icon ? (
            <TMIcon
              name={
                firstRenewMango?.mango?.customRenewCardAfterExpiry
                  ?.icon as IconName
              }
              size={20}
              color={COLORS.BACKGROUND}
            />
          ) : (
            <PiWarningOctagonFill size={20} color={COLORS.BACKGROUND} />
          )}
        </div>
        <div className="feed-card__details-wrapper compact">
          <div className="feed-card-details">
            <div className="feed-card__header">
              <span>
                {dynamicItemTitle(
                  renewMangoes.length > 1 ? 'mangoes' : 'mango',
                  'title',
                )}{' '}
                expired!
              </span>
            </div>

            {renewMangoes.length > 1 ? (
              <div className="feed-card__title">
                {renewMangoes.length} {dynamicItemTitle('mangoes')} have
                expired. Renew now!
              </div>
            ) : (
              <>
                <div
                  className="feed-card__title"
                  style={{
                    fontSize: 14,
                  }}>
                  {firstRenewMango?.mango?.customRenewCardAfterExpiry
                    ?.message ? (
                    <CustomParsedReadMoreContent
                      text={
                        firstRenewMango?.mango?.customRenewCardAfterExpiry
                          ?.message
                      }
                      style={{ fontSize: 13 }}
                    />
                  ) : (
                    <b>{firstRenewMango.mango.title}</b>
                  )}
                </div>

                <div className="feed-card__subtitle" style={{ fontSize: 13 }}>
                  {firstRenewMango?.mango?.customRenewCardAfterExpiry
                    ?.buttonText ? (
                    <Button
                      type="link"
                      className="siteBtn siteBtnLink sm"
                      onClick={onClick}
                      style={{ color: COLORS.LINK }}>
                      {
                        firstRenewMango?.mango?.customRenewCardAfterExpiry
                          ?.buttonText
                      }
                    </Button>
                  ) : (
                    <>
                      Renew now for <Rupee />
                      {newNumberFormat(firstRenewMango.mango.price)}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          <div className="feed-card__arrow">
            <IoClose
              size={24}
              color={COLORS.ICON}
              onClick={(e) => {
                e.stopPropagation();
                setHideRenewMangoes(true);
              }}
            />
            <IoChevronForward size={24} color={COLORS.ICON} />
          </div>
        </div>
      </div>

      <BottomSheet
        open={showModal}
        onDismiss={() => setShowModal(false)}
        header={
          <Header
            canGoBack={false}
            title={`Renew ${dynamicItemTitle('mangoes')}`}
            noBorder
          />
        }>
        {renewMangoes.map((renewMango) => (
          <RenewMangoTile
            key={renewMango?.mango?._id}
            renewMango={renewMango}
            onClick={() => {
              handleRenewalRedirect(
                renewMango?.mango?._id,
                renewMango?.mango?.customRenewCardAfterExpiry?.buttonLink,
              );
              setShowModal(false);
            }}
          />
        ))}
      </BottomSheet>
    </>
  );
};

export default React.memo(RenewMangoes);
